import { FC, useEffect, useRef } from 'react'
import { Stack } from '@mui/material'
import { useGalleryVisualSelection, useGalleryVisualsDownloadArchive, useGalleryVisualsMeta } from '../../contexts'

import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import { MUIButton } from 'components/common/MUIButton'
import { useClientGallery } from '../_main/contexts'
import { useTranslation } from 'react-i18next'

/**
 * Client gallery actions panel which including feedback button, editing and download setting.
 * 
 * @example <ClientGalleryActionsPanel />
 */
export const ClientGalleryActionsPanel: FC = () => {
  const { t } = useTranslation(['gallery'])

  const { purchasedVisualsCount } = useGalleryVisualsMeta()
  const { initiateArchiveDownload } = useGalleryVisualsDownloadArchive()
  const { setIsToolBarOpen } = useClientGallery()
  const {
    selectAllPurchased,
    selectedPurchasedVisualsCount,
  } = useGalleryVisualSelection()

  const downloadAllPurchasedTriggered = useRef(false)

  useEffect(() => {
    if (downloadAllPurchasedTriggered.current && (selectedPurchasedVisualsCount === purchasedVisualsCount)) {
      downloadAllPurchasedTriggered.current = false
      initiateArchiveDownload()
    }
  }, [initiateArchiveDownload, purchasedVisualsCount, selectedPurchasedVisualsCount])

  return (
    <Stack flexDirection={{ xs: 'column-reverse', sm: 'row' }} justifyContent="space-between" alignItems={{ xs: 'flex-start', sm: 'space-between' }} gap={{ xs: '1rem', sm: '0' }}>
      <MUIButton
        type='secondaryBorder'
        size='sm'
        variant='outlined'
        startIcon={<FileDownloadOutlinedIcon />}
        onClick={() => {
          selectAllPurchased()
          setIsToolBarOpen(true)
        }}
      >
        {t('download_visuals')}
      </MUIButton>

    </Stack>
  )
}
